import type { FichaContenedor } from '../api';

export type Pestana = 'resumen' | 'pallets' | 'recepcion' | 'salidas' | 'datos' | 'eliminados';

/**
 * Las pestañas de la ficha del contenedor, con cuántos hay en cada una.
 * Recepción sólo si hubo borrador y Eliminados sólo si se eliminó alguno: una
 * pestaña que siempre está vacía es una pestaña que se deja de mirar.
 */
export function pestanasDeFicha(
  f: Pick<FichaContenedor, 'pallets' | 'recepcion' | 'salidas' | 'eliminados'>,
): { id: Pestana; texto: string }[] {
  const con = (texto: string, n: number) => (n > 0 ? `${texto} (${n})` : texto);
  return [
    { id: 'resumen' as const, texto: 'Resumen' },
    { id: 'pallets' as const, texto: con('Pallets', f.pallets.length) },
    ...(f.recepcion.lineas.length > 0 ? [{ id: 'recepcion' as const, texto: con('Recepción', f.recepcion.lineas.length) }] : []),
    { id: 'salidas' as const, texto: con('Salidas', f.salidas.length) },
    { id: 'datos' as const, texto: 'Datos y documentos' },
    ...(f.eliminados.length > 0 ? [{ id: 'eliminados' as const, texto: con('Eliminados', f.eliminados.length) }] : []),
  ];
}
